"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Product_1 = __importDefault(require("../entity/Product"));
const CategoryStub_1 = __importDefault(require("./CategoryStub"));
class ProductStub extends Product_1.default {
    constructor({ id = 'ABC', name = 'testProduct', category = new CategoryStub_1.default() } = {}) {
        super({ id, name, category });
    }
}
exports.default = ProductStub;
